import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Badge, Empty } from "@/components/Kit";
import { Boxes, IndianRupee, BookMarked, AlertTriangle, Printer } from "lucide-react";

const inr = (n) => "₹" + (n || 0).toLocaleString("en-IN");
const MOVE = { stock_in: "#10B981", issue: "#06B6D4", return: "#4F46E5", lost: "#F43F5E" };

export default function StockReportTab() {
  const { data: r } = useQuery({ queryKey: ["inv-report"], queryFn: async () => (await api.get("/school/inventory/report")).data });
  if (!r) return null;
  const kpis = [
    [Boxes, "Units in stock", r.stock_units, `${r.items} items`],
    [IndianRupee, "Stock value", inr(r.stock_value), "at list price"],
    [BookMarked, "Currently issued", r.issued_units, "with students"],
    [AlertTriangle, "Lost · fines", r.lost_units, `${inr(r.fines_total)} added to dues`],
  ];
  return (
    <div data-testid="stock-report">
      <div className="mb-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {kpis.map(([I, l, v, s]) => (
          <div key={l} className="ep-card p-5"><I size={18} className="text-indigo-300" /><p className="mt-3 text-2xl font-bold font-head text-white">{v}</p><p className="text-xs uppercase tracking-wider text-slate-500">{l}</p><p className="mt-1 text-xs text-slate-400">{s}</p></div>
        ))}
      </div>
      <div className="grid gap-5 lg:grid-cols-2">
        <div className="ep-card overflow-hidden">
          <div className="flex items-center justify-between border-b border-slate-800 px-4 py-3"><p className="text-sm font-semibold text-white">Low stock — reorder</p><button className="ep-btn ep-btn-ghost !px-2.5 !py-1.5 text-xs" onClick={() => window.print()} data-testid="inv-print-btn"><Printer size={13} /> Print</button></div>
          <table className="w-full text-sm print-area" data-testid="low-stock-table">
            <tbody>
              {r.low_stock.map((i) => <tr key={i.id} className="border-b border-slate-800/50"><td className="px-4 py-2.5 text-white">{i.name}</td><td className="px-4 py-2.5 text-xs text-slate-400">{i.class_name ? `Class ${i.class_name}` : "All"}</td><td className="px-4 py-2.5 text-right font-mono text-rose-400">{i.stock} / {i.reorder_level}</td></tr>)}
              {!r.low_stock.length && <tr><td><Empty>All items are above reorder level</Empty></td></tr>}
            </tbody>
          </table>
        </div>
        <div className="ep-card overflow-hidden">
          <p className="border-b border-slate-800 px-4 py-3 text-sm font-semibold text-white">Recent stock movements</p>
          <table className="w-full text-sm" data-testid="moves-table">
            <tbody>
              {r.recent_moves.slice(0, 15).map((m) => <tr key={m.id} className="border-b border-slate-800/50"><td className="px-4 py-2"><Badge color={MOVE[m.type]}>{m.type.replace("_", " ")}</Badge></td><td className="px-4 py-2 text-slate-300">{m.item_name}<p className="text-[11px] text-slate-500">{m.note}</p></td><td className={`px-4 py-2 text-right font-mono ${m.qty > 0 ? "text-emerald-400" : "text-rose-400"}`}>{m.qty > 0 ? `+${m.qty}` : m.qty}</td></tr>)}
              {!r.recent_moves.length && <tr><td><Empty>No movements yet</Empty></td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
